import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "table valign-top" }
const _hoisted_2 = { style: {"width":"40%"} }
const _hoisted_3 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_4 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["href"]

import CoreUiDialogStatisticCard from "~/core-ui/vue/chat/CoreUiDialogStatisticCard.vue";
import Dictionary from "~/ts/library/Dictionary";
import {computed} from "vue";
import ElCardSectionWithTable from "~/cabinet/vue/interface/card/ElCardSectionWithTable.vue";
import {localeDateTimeString} from "~/core-ui/ts/CoreUiHelpersMixin";
import {__} from "~/ts/library/Translate";


import {defineComponent} from "vue";

const __default__ = defineComponent({
    name: "CoreUiDialogStatisticDialog"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    dialogId: {},
    result: {},
    operatorsDictionary: {},
    showOperatorLogins: { type: Boolean },
    inCabinet: { type: Boolean }
  }, {
    "visible": { type: Boolean },
    "visibleModifiers": {},
  }),
  emits: ["update:visible"],
  setup(__props: any) {

let props = __props;

let isVisible = _useModel<boolean>(__props, "visible");
function close() {
    isVisible.value = false;
}

function getOperator(login: string): { descr: string, avatar?: string } {
    let operator = props.operatorsDictionary[login];
    if (!operator) {
        return {
            descr: props.showOperatorLogins ? login : `Не найден`
        }
    } else {
        return {
            descr: props.showOperatorLogins ? `${operator.fio} (${operator.login})` : operator.fio,
            avatar: operator.avatar
        }
    }
}

let showAllOperators = computed(() => {
    let result = true;
    if (props.result.operators.length == 1) {
        result = JSON.stringify(props.result.operators[0].statistic) !== JSON.stringify(props.result.allOperators);
    }
    return result;
})

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: _unref(__)(`Статистика диалога %s`, `№${__props.dialogId}`),
    modelValue: _unref(isVisible),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(isVisible) ? (isVisible).value = $event : isVisible = $event)),
    width: "800px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_row, { class: "el-row-root" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, null, {
                default: _withCtx(() => [
                  _createVNode(ElCardSectionWithTable, null, {
                    default: _withCtx(() => [
                      _createElementVNode("table", _hoisted_1, [
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_2, _toDisplayString(_unref(__)("Дата начала диалога")), 1),
                            _createElementVNode("td", null, _toDisplayString(_unref(localeDateTimeString)(__props.result.dialog.dateTimeOpen, true)), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", null, _toDisplayString(_unref(__)("Дата окончания диалога")), 1),
                            _createElementVNode("td", null, [
                              (__props.result.dialog.dateTimeClose)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(_unref(localeDateTimeString)(__props.result.dialog.dateTimeClose, true)) + " ", 1),
                                    (__props.result.dialog.dateTimeCloseReal && __props.result.dialog.dateTimeCloseReal !== __props.result.dialog.dateTimeClose)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(__)("Реальное время завершения")) + ": " + _toDisplayString(_unref(localeDateTimeString)(__props.result.dialog.dateTimeCloseReal, true)), 1))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(__)("Ещё не завершён")), 1))
                            ])
                          ]),
                          (__props.result.dialog.dateTimeClose)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                                _createElementVNode("td", null, _toDisplayString(_unref(__)("Оператор, завершивший диалог")), 1),
                                _createElementVNode("td", null, [
                                  (__props.result.dialog.closedByOperator)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (getOperator(__props.result.dialog.closedByOperator))
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createTextVNode(_toDisplayString(getOperator(__props.result.dialog.closedByOperator).descr), 1)
                                            ], 64))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createTextVNode(_toDisplayString(__props.result.dialog.closedByOperator), 1)
                                            ], 64))
                                      ], 64))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(__)("Диалог завершён автоматически")), 1))
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (__props.inCabinet)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                                _cache[1] || (_cache[1] = _createElementVNode("td", null, null, -1)),
                                _createElementVNode("td", null, [
                                  _createElementVNode("a", {
                                    target: "_blank",
                                    textContent: 'Внешняя ссылка на диалог',
                                    href: __props.result.dialog.publicLink
                                  }, null, 8, _hoisted_8)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_unref(showAllOperators))
                ? (_openBlock(), _createBlock(CoreUiDialogStatisticCard, {
                    key: 0,
                    statistic: __props.result.allOperators,
                    title: _unref(__)('Все операторы')
                  }, null, 8, ["statistic", "title"]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.result.operators, (item) => {
                return (_openBlock(), _createBlock(CoreUiDialogStatisticCard, {
                  key: item.login,
                  avatar: getOperator(item.login).avatar,
                  statistic: item.statistic,
                  title: getOperator(item.login).descr
                }, null, 8, ["avatar", "statistic", "title"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}
}

})